import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Button from '../components/Button/Button';
import Input from '../components/Input/Input';
import Checkbox from '../components/Checkbox/Checkbox';
import styles from './Pages.module.css';

const API_URL = '/api';

const AdminLoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || '/map/admin/dashboard';

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        try {
            const response = await fetch(`${API_URL}/auth/check`, { 
                credentials: 'include' 
            });
            const data = await response.json();
            if (data.authenticated) {
                navigate(from, { replace: true });
            }
        } catch (err) {
            console.error('Auth check failed:', err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_URL}/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
                credentials: 'include'
            });

            const data = await response.json();

            if (response.ok && data.success) {
                navigate(from, { replace: true });
            } else {
                setError(data.message || 'Ошибка входа');
            }
        } catch (err) {
            setError('Не удалось подключиться к серверу');
            console.error('Login error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.loginPage}>
            <div className={styles.loginContainer}>
                {/* Левая часть - брендинг */}
                <div className={styles.brandSection}>
                    <div className={styles.logo}>
                        <span className={styles.logoText}>SPD</span>
                    </div>
                    <h1 className={styles.brandTitle}>IChisSPD</h1>
                    <p className={styles.brandSubtitle}>Система управления территорией</p>
                    <p className={styles.brandDescription}>
                        Административная панель для управления картой территории
                    </p>
                </div>

                {/* Правая часть - форма входа */}
                <div className={styles.formSection}>
                    <div className={styles.formHeader}>
                        <h2>Вход в админ панель</h2>
                        <p>Введите свои учетные данные для доступа</p>
                    </div>

                    <form className={styles.loginForm} onSubmit={handleSubmit}>
                        {error && (
                            <div className={styles.errorMessage} style={{ 
                                padding: '12px', 
                                backgroundColor: '#fee2e2', 
                                borderRadius: '6px', 
                                color: '#dc2626',
                                marginBottom: '16px' 
                            }}>
                                {error}
                            </div>
                        )}
                        <div className={styles.formGroup}>
                            <Input
                                label="Имя пользователя"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="admin"
                                required
                                fullWidth
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <Input
                                label="Пароль"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                                fullWidth
                            />
                        </div>

                        <div className={styles.formOptions}>
                            <Checkbox
                                checked={rememberMe}
                                onChange={setRememberMe}
                                label="Запомнить меня"
                            />
                        </div>

                        <Button
                            type="submit"
                            variant="primary"
                            fullWidth
                            size="large"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Вход...' : 'Войти'}
                        </Button>
                    </form>

                    <div className={styles.formFooter}>
                        <p>
                            <Link to="/map" className={styles.link}>
                                Вернуться на публичную карту
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLoginPage;
